import { InterventionStatus } from '@arhs-fleetback/types/entities/interventions';
import { createSelector } from 'reselect';

import { SELF_SERVICE_ORIGIN, SELF_SERVICE_STATUS } from 'constants/SelfServiceConstants';
import { getProps, getSecondProps } from 'utils/selectors';

import { isSelfServiceStatusBelow } from '../utils/selfServiceStatus';

export const getState = state => state.interventions;

export const getUIState = createSelector(getState, /** @returns {import('../reducers/ui').UIState} */ state => state.ui);

export const getDataEntities = createSelector(getState, state => state.data?.entities ?? {});

export const getByIds = createSelector(getDataEntities, getProps, (interventions, ids) =>
  ids.map(id => interventions?.[id]));

export const getById = createSelector(getDataEntities, getProps, (interventions, id) => interventions?.[id]);

export const isInterventionToBeSent = createSelector(
  getById,
  intervention => intervention?.status === InterventionStatus.TO_BE_SENT
);

const getSelfServiceByType = createSelector(getById, getSecondProps, (intervention, type) => intervention?.selfServices?.find(selfService => selfService.type === type));

export const getSelfServiceOriginContext = createSelector(getSelfServiceByType, (selfService) => selfService?.originContext);

export const isKioskCheckOutAndHomeCompleted = createSelector(
  getSelfServiceOriginContext,
  (originContext) => {
    const isKioskNotAnswered = isSelfServiceStatusBelow(
      originContext?.[SELF_SERVICE_ORIGIN.KIOSK]?.status,
      SELF_SERVICE_STATUS.ANSWERED
    );
    const isHomeAnswered = !isSelfServiceStatusBelow(
      originContext?.[SELF_SERVICE_ORIGIN.HOME]?.status,
      SELF_SERVICE_STATUS.ANSWERED
    );
    return isKioskNotAnswered && isHomeAnswered;
  }
);

export const getSelectedInterventionId = createSelector(getUIState, ui => ui.selectedInterventionId);

export const getSelectedIntervention = createSelector(
  [getDataEntities, getSelectedInterventionId],
  (entities, id) => entities?.[id]
);

export const isRebrandingSelector = createSelector(getUIState, ({ isRebranding }) => isRebranding);

const getMessagesIdsState = createSelector(getState, state => state.messageIds);

export const getMessageIdsById = createSelector(getMessagesIdsState, getProps, (state, id) => state[id]);
